import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN = {
  'loading': false,
  'chassisArray': [],
  'dealersArray': [],
  'chassisExcelFile': '',
  'loadingChassisExcelFile': false,
};

export const campaignChassis = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN, {
    [ActionTypes.FETCHING_CAMPAIGN_BY_ID]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID]: (state, action) => {
      const {chassisArray, dealersArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'chassisArray': chassisArray || [],
        'dealersArray': dealersArray || [],
      };
    },
    [ActionTypes.FETCHED_CAMPAIGN_BY_ID_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'chassisArray': [],
      'dealersArray': [],
    }),
    [ActionTypes.ADDING_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADDED_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'chassisArray': [],
      'dealersArray': [],
    }),
    [ActionTypes.ADDED_CAMPAIGN_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'chassisArray': [],
      'dealersArray': [],
    }),
    [ActionTypes.CLEAR_CAMPAIGN]: (state, action) => ({
      ...state,
      'loading': false,
      'chassisArray': [],
      'dealersArray': [],
    }),
    [ActionTypes.PROCESSING_CAMPAIGN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS]: (state, action) => {
      const {chassisArray, dealersArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'chassisArray': chassisArray,
        'dealersArray': dealersArray,
      };
    },
    [ActionTypes.PROCESSED_CAMPAIGN_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'chassisArray': [],
      'dealersArray': [],
    }),
    [ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_CHASSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS]: (state, action) => {
      const {chassisArray, dealersArray} = action.response.data;
      return {
        ...state,
        'loading': false,
        'chassisArray': chassisArray,
        'dealersArray': dealersArray,
      };
    },
    [ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_CHASSIS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_REQUEST]: (state, action) => ({
      ...state,
      'loadingChassisExcelFile': true,
    }),
    [ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_SUCCESS]: (state, action) => ({
      ...state,
      'loadingChassisExcelFile': false,
      'chassisExcelFile': action.response.data,
    }),
    [ActionTypes.DOWNLOAD_CAMPAIGN_CHASSIS_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loadingChassisExcelFile': false,
      'chassisExcelFile': '',
    }),
    [ActionTypes.CLEAR_CHASSIS_EXCEL_FILE]: (state, action) => ({
      ...state,
      'chassisExcelFile': '',
    }),
  })(state, action);
};
